<div class="app-container">
  <!-- Loading indicator while translations are being loaded -->
  <!-- Shows on initial load and language switches -->
  <div *ngIf="isLoadingTranslations" class="translation-loading-overlay" [class.language-switch]="!isLoadingTranslations">
    <div class="loading-spinner-container">
      <div class="loading-spinner"></div>
      <p class="loading-text">Loading...</p>
    </div>
  </div>

  <!-- Main app content - only shown after translations are ready -->
  <div *ngIf="!isLoadingTranslations" class="route-transition-container">
    <router-outlet></router-outlet>
  </div>
</div>
